import type { ReactNode } from 'react';

import { createPortal } from 'react-dom';

type PortalProps = {
  children: ReactNode;
};
const Portal = ({ children }: PortalProps): ReactNode => {
  if (typeof document !== 'object') {
    return <></>;
  }
  return createPortal(children, document.body) as ReactNode;
};

export default Portal;
